var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoardBatten(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 184,
    height: 22,
    viewBox: "0 0 184 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21116",
    "data-name": "Rectangle 21116",
    width: 184,
    height: 22,
    transform: "translate(1475 477)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_21106",
    x: -1,
    y: -16,
    width: 32,
    height: 54,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_21108",
    x: -7,
    y: -16,
    width: 32,
    height: 54,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_21106-2",
    x: 91,
    y: -16,
    width: 32,
    height: 54,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_21108-2",
    x: 85,
    y: -16,
    width: 32,
    height: 54,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_21106-3",
    x: 183,
    y: -16,
    width: 32,
    height: 54,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_21108-3",
    x: 177,
    y: -16,
    width: 32,
    height: 54,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_37",
    "data-name": "Mask Group 37",
    transform: "translate(-1475 -477)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15894",
    "data-name": "Group 15894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15889",
    "data-name": "Group 15889",
    transform: "translate(-102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37856",
    "data-name": "Path 37856",
    d: "M0,0H71V42H0Z",
    transform: "translate(1598 467)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1577, 477)",
    filter: "url(#Rectangle_21106)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21106-4",
    "data-name": "Rectangle 21106",
    width: 20,
    height: 42,
    transform: "translate(1 -10)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1577, 477)",
    filter: "url(#Rectangle_21108)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21108-4",
    "data-name": "Rectangle 21108",
    width: 20,
    height: 42,
    transform: "translate(1 -10)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21109",
    "data-name": "Rectangle 21109",
    width: 1,
    height: 42,
    transform: "translate(1577 467)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15890",
    "data-name": "Group 15890",
    transform: "translate(-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37855",
    "data-name": "Path 37855",
    d: "M0,0H71V42H0Z",
    transform: "translate(1598 467)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1485, 477)",
    filter: "url(#Rectangle_21106-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21106-5",
    "data-name": "Rectangle 21106",
    width: 20,
    height: 42,
    transform: "translate(93 -10)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1485, 477)",
    filter: "url(#Rectangle_21108-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21108-5",
    "data-name": "Rectangle 21108",
    width: 20,
    height: 42,
    transform: "translate(93 -10)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21109-2",
    "data-name": "Rectangle 21109",
    width: 1,
    height: 42,
    transform: "translate(1577 467)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15895",
    "data-name": "Group 15895",
    transform: "translate(82)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21105",
    "data-name": "Rectangle 21105",
    width: 71,
    height: 42,
    transform: "translate(1598 467)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1393, 477)",
    filter: "url(#Rectangle_21106-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21106-6",
    "data-name": "Rectangle 21106",
    width: 20,
    height: 42,
    transform: "translate(185 -10)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1393, 477)",
    filter: "url(#Rectangle_21108-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21108-6",
    "data-name": "Rectangle 21108",
    width: 20,
    height: 42,
    transform: "translate(185 -10)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21109-3",
    "data-name": "Rectangle 21109",
    width: 1,
    height: 42,
    transform: "translate(1577 467)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardBatten);
export default __webpack_public_path__ + "static/media/board_batten.6397fe5a0da1bd82be943b54e065caea.svg";
export { ForwardRef as ReactComponent };